import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/doujinshi";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于同人志典藏站，你可能想问"
          desc="整理了读者最常问到的几个问题，如果还有疑问，欢迎通过页面底部联系我们。"
        />

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-label text-base text-foreground-950">{f.q}</span>
                  <span
                    className={`grid h-8 w-8 shrink-0 items-center justify-center rounded-full text-primary-600 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </div>
    </section>
  );
}